import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const ArrowIcon = styled.span`
  margin: 0 5px;
`;

export const Button = styled.button`
  padding: 8px 10px;
  margin: 5px 0;
  border: none;
  background: ${(props) => (props.selected ? colors.white + '50' : colors.blue1)};
  color: ${(props) => (props.selected ? colors.blue1 : colors.white)};
  border-radius: 3.6px;
  grid-row-start: left-top;
  grid-row-end: left-bot;
  font-size: 9px;
  line-height: 11px;
  font-weight: 500;
  letter-spacing: 0.507656px;
  text-transform: uppercase;
  outline: none;
`;

export const TopLabel = styled.div`
  grid-area: mid-top;
  font-size: 15px;
  line-height: 20px;
  color: ${(props) => (props.selected ? colors.white : colors.black1)};
  letter-spacing: -0.275707px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BotLabel = styled.div`
  grid-area: mid-bot;
  font-size: 11px;
  line-height: 18px;
  color: ${(props) => (props.selected ? colors.white : colors.lightGray2)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Icon = styled.div`
  background-image: url(${(props) => props.url});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  grid-area: icon;
  place-self: center;
`;

export const TicketWrapper = styled.li`
  background: ${(props) => (props.selected ? colors.blue1 : colors.white)};
  width: 100%;
  padding: 13px 16px;
  font-family: 'Roboto', sans-serif;
  display: grid;
  grid-template-columns: 25px auto 65px;
  grid-column-gap: 15px;
  grid-template-areas:
    'icon mid-top left-top'
    'icon mid-bot left-bot';
`;

export const CtaTicketsTabWrapper = styled.ul`
  padding: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 0;
  border-bottom: 7px solid ${colors.lightGray10};
`;
